var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDropdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 7,
    viewBox: "0 0 12 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Down 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11 1.5L9.25269 3.26297C7.85925 4.6689 7.16253 5.37187 6.31333 5.48011C6.10527 5.50663 5.89473 5.50663 5.68667 5.48011C4.83748 5.37187 4.14075 4.6689 2.74731 3.26297L1 1.5",
    stroke: "#8F8F8F",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdown);
export default __webpack_public_path__ + "static/media/dropdown.deea44eca998796fa4c34853dcf714ea.svg";
export { ForwardRef as ReactComponent };